import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';

const IconHektor = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconHektor"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M20.732 1.606Q18.072.001 12.028 0C8 0 5.263.482 3.602 1.44 1.198 2.767 0 5.19 0 8.697v6.653c0 3.472 1.198 5.875 3.602 7.21C5.263 23.524 8.074 24 12.028 24s6.85-.538 8.704-1.606Q24.001 20.457 24 15.35V8.698c0-3.435-1.093-5.8-3.268-7.098zm1.446 9.248c-.34 1.223-1.551 4.337-5.783 4.337 0 0-2.378.05-4.392-1.712-2.014 1.761-4.392 1.712-4.392 1.712-4.232 0-5.443-3.108-5.782-4.337-.025-.099.105-.16.16-.074.396.587 1.273 1.433 3.033 1.433 1.532 0 3.83-1.452 4.658-2.008a.8.8 0 0 1 .692-.105l1.637.476 1.637-.476a.83.83 0 0 1 .692.105c.828.563 3.126 2.008 4.658 2.008 1.76 0 2.638-.846 3.033-1.433.056-.087.186-.025.161.074z" />
  </svg>
);

const ForwardRef = /* #__PURE__ */ forwardRef(IconHektor);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
